var _circle, _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeadV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0001,
    cy: 14.9995,
    r: 14.5,
    fill: "#513795",
    fillOpacity: 0.11,
    stroke: "url(#paint0_radial_15_10)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5515 14.7555C23.6516 13.0581 20.7884 12.8156 20.134 12.8964C20.2976 13.2197 24.4697 14.3513 23.488 15.4829C22.3957 16.742 17.7617 17.0994 14.8167 17.0994C11.8717 17.0994 8.7299 16.7007 7.12705 16.0486C5.73637 15.4829 5.98178 14.7554 6.22719 14.4321C6.78681 13.6949 8.35412 13.2197 9.17217 12.8964C7.37246 12.8964 5.00012 14.028 5.00012 15.0787C5.16373 17.3419 9.82634 18.0711 10.3992 18.1501C13.9168 18.6351 15.962 18.6351 18.7433 18.1501C21.2459 17.7138 25.5027 16.5497 24.5515 14.7555Z",
    fill: "#6648B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1654 21.2409L6.39075 8.04665C8.67059 7.85075 9.84318 8.27605 10.7755 9.12595C11.3986 9.694 11.7951 10.4595 12.1284 11.234L14.5887 16.9498C14.6277 17.0405 14.717 17.0992 14.8158 17.0992C14.9154 17.0992 15.0053 17.0394 15.0438 16.9476C15.7297 15.3126 17.2011 11.8478 18.0888 9.90565C19.005 7.90116 21.9064 7.88499 23.2425 8.12747L17.5472 21.2338C17.0813 22.306 16.0238 22.9995 14.8548 22.9995C13.6886 22.9995 12.633 22.3092 12.1654 21.2409Z",
    fill: "url(#paint1_radial_15_10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2356 16.7759L6.39075 8.04665C8.24959 7.88692 9.37235 8.14016 10.229 8.69979C11.3205 9.41292 11.8873 10.6738 12.4028 11.8714L14.653 17.0992C14.653 17.0992 13.6714 17.0992 12.4443 17.0184C11.2987 16.9429 10.2356 16.7759 10.2356 16.7759Z",
    fill: "url(#paint2_radial_15_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_15_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.591 -1.87549) rotate(83.1199) scale(32.299 59.1035)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8ADFB",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465667,
    stopColor: "#684FAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2887"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.9017 7.06201) rotate(82.2802) scale(16.1798 33.1377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B677E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623FC4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_15_10",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5001 8.99951) rotate(69.7751) scale(10.1242 33.1529)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B677E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#623FC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeadV);
export default __webpack_public_path__ + "static/media/IconHeadV.afa3cd7151a09db5f317f410268172d6.svg";
export { ForwardRef as ReactComponent };